import React from 'react';
import PlaceholderPage from '../../components/PlaceholderPage';

const GymAttendance = () => <PlaceholderPage title="출석 관리" description="회원 출석 현황을 확인해요." />;

export default GymAttendance;
